import styled from 'styled-components'
import { theme } from '../../../config';

const Wrapper = styled.div`
  background: ${theme.colors.white};
  padding: 25px;
  box-shadow: 0px 0px 4px rgba(176, 139, 0, 0.1);
  border-radius: 8px;
  height: 100%;
  width: 100%;
`;


const InsightsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const DropdownWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const IconWrapper = styled.img`
  height: 50px;
  width: 50px;
`;

const DetailsWrapper = styled.div`
  flex-direction: column;
  display: flex;
  gap: 8px;
  margin-top: 1em;
`;

const Header = styled.div`
  display: flex; 
  flex-direction: row;
`;

const TitleWrapper = styled.div`
  font-family: 'Orkney Bold';
  display: flex;
  flex: 1;
  font-size: 16px;
  font-weight: 700;
  color: #273049
`;

const Item = styled.div<{ type: 'accepted' | 'declined' | 'waiting' }>`
  background: ${({ type }) => type === 'accepted' ? '#7DB20B' : type === 'declined' ? '#C9273F' : '#1876CC'};
  height: 35px;
  position: relative;
  color: ${theme.colors.white};

  &:after {
    font-size: 11px;
    content: attr(data-title);
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 35px;
    height: 100%;
    width: 100%;
    background: rgba(255,255,255,.2);
    display: flex;
    align-items: center;
    padding-left: 10px;
    font-weight: 400;
    font-style: normal;
  }
`;

const ItemCount = styled.div`
  width: 35px;
  height: 100%;
  align-items: center;
  display: flex;
  justify-content: center;
  font-weight: 500;
  font-size: 16px;
}
`;

export { Wrapper, InsightsWrapper, DropdownWrapper, DetailsWrapper, IconWrapper, TitleWrapper, Header, Item, ItemCount }